export default "__VITE_ASSET__37bb62f0__"